import Vue from 'vue';

function showSnackBar(state, snackbar) {
	Vue.set(state.appConfig, 'snackbar', snackbar);
}

function toggleLoading(state, value) {
	Vue.set(state.appConfig, 'isLoading', value);
}

const methods = {
	showSnackBar,
	toggleLoading,
};

export default methods;



// WEBPACK FOOTER //
// ./src/store/mutations.js